import React, { Component } from 'react';
import AudioJoinerHeaderRender from './children/AudioJoinerHeaderRender';
import { message, Upload } from 'antd';
import Utils from '@/utils';
import { withTranslation } from 'react-i18next';
import sentGAEvent from '@/ga';
import '@/assets/audioJoiner.less';

class AudioJoinerHeaderFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.stopUpload = false;
  }

  uploadProps = {
    accept: this.props.accept,
    maxCount: 2,
    multiple: true,
    showUploadList: false,
    beforeUpload: async (file, fileList) => {
      if (this.stopUpload) {
        if (file.uid === fileList[fileList.length - 1].uid) {
          this.stopUpload = false;
        }
        return Upload.LIST_IGNORE;
      }
      sentGAEvent({
        category: 'audio_merge_add_files',
        action: 'audio_merge_add_files_format',
        label:
          (fileList.length + this.props.audioJoinerList.length > 5
            ? 5 - this.props.audioJoinerList.length
            : fileList.length) + '_add',
      });
      this.stopUpload = true;
      if (
        fileList.length > 5 ||
        this.props.audioJoinerList.length + fileList.length > 5
      ) {
        message.warn(
          this.props.t('Support merging audio files at most', { num: 5 })
        );
      }
      const audioJoinerList = [...this.props.audioJoinerList];
      for (let index = 0; index < fileList.length; index++) {
        let item = fileList[index];
        // if (item.size >= 20 * 1024 * 1024) {
        //   if (Utils.isNeedToShowPurchaseModal()) {
        //     this.props.handlePurchaseModalObjChange({
        //       visible: true,
        //       type: "uploadSizeBiggerThanLimit",
        //     });
        //     return Upload.LIST_IGNORE;
        //   }
        // } else
        if (!Utils.validate(item, this.props.accept)) {
          message.warn(`The file ${item.name} format is not supported!`);
        } else if (audioJoinerList.length < 5) {
          if (item.size >= 20 * 1024 * 1024) {
            if (Utils.isNeedToShowPurchaseModal()) {
              this.props.handlePurchaseModalObjChange({
                visible: true,
                type: 'uploadSizeBiggerThanLimit',
                trigger: 'SizeExceed20M',
              });
              let action = Utils.gaUpgradePromptShow(this.props.work);
              if (action) {
                sentGAEvent({
                  category: 'UpgradePrompShow',
                  action: action,
                  label: 'Null',
                });
              }
              return Upload.LIST_IGNORE;
            }
          }
          let fileToBlobResponse = await Utils.fileToBlob(file);
          if (fileToBlobResponse) {
            sentGAEvent({
              category: 'audio_merge_add_files',
              action: 'audio_merge_add_files_num',
              label:
                /\.[^.]+$/.exec(item.name)[0].toLocaleLowerCase() +
                '_' +
                Utils.changeTimeToGAString(
                  Utils.getSeconds(fileToBlobResponse.duration)
                ) +
                '_' +
                (item.size / 1024 / 1024).toFixed(2),
            });
            const newFile = {
              name: item.name,
              guid: new Date().getTime() + index,
              size: item.size,
              status: 'ready',
              uploadStatus: false,
              fileObj: item,
              videofileurl: fileToBlobResponse.blobUrl,
              duration: fileToBlobResponse.duration,
              type: item.type,
              start: '00:00.00',
              end: fileToBlobResponse.duration,
            };
            if (audioJoinerList[audioJoinerList.length - 1].fadeOut) {
              newFile.fadeIn = true;
            }
            audioJoinerList.push(newFile);
          }
        }
      }
      console.log('处理完毕，添加进list');
      this.props.onAudioJoinerListChange(audioJoinerList);
      return Upload.LIST_IGNORE;
    },
  };

  handleStopUpload = () => {
    this.stopUpload = false;
  };

  render() {
    console.log('this.props.accept', this.props.accept);
    return (
      <AudioJoinerHeaderRender
        uploadProps={this.uploadProps}
        audioJoinerList={this.props.audioJoinerList}
        handleStopUpload={this.handleStopUpload}
      />
    );
  }
}

export default withTranslation(['common'])(AudioJoinerHeaderFunction);
